module.exports = __webpack_public_path__ + "img/936451_C29A8F_5F3A2B_361D14-256px.79574d84.png";